/**
 * ============================================================
 * MONTE HERMOM | PRIVATE ROUTE (GUARDIÃO SOBERANO)
 * ============================================================
 *
 * ARQUIVO: PrivateRoute.jsx
 * VERSÃO: 2.1.0
 * DATA: 15/09/2026
 *
 * CORREÇÃO v2.1.0:
 * - Redirect para /login/ via window.location.href (HTTP real)
 *   em vez de <Navigate> (client-side, não bate no PHP)
 * - Remove risco de loop com React Router
 * - Força recarga completa quando não autenticado
 *
 * CAMINHO:
 * /src/components/auth/PrivateRoute.jsx
 * ============================================================
 */

import React from 'react';
import { useAuthSaaS } from '../../context/AuthSaaSContext';

/**
 * @param {ReactNode} children
 * @param {number} nivelMinimoSeguranca (opcional)
 */
export function PrivateRoute({ children, nivelMinimoSeguranca = 1 }) {
  const { autenticado, usuario, loading } = useAuthSaaS();

  // ========================================================
  // 1. Estado de carregamento do contexto
  // ========================================================
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-950 text-white font-black italic">
        VALIDANDO SOBERANIA…
      </div>
    );
  }

  // ========================================================
  // 2. Não autenticado → força request HTTP ao PHP
  //    (window.location.href, não <Navigate>)
  // ========================================================
  if (!autenticado) {
    // Redireciona de forma definitiva para o login PHP.
    // Usar replace() evita poluir o histórico do navegador.
    if (typeof window !== 'undefined') {
      window.location.replace('/login/');
    }
    return null;
  }

  // ========================================================
  // 3. Autenticado mas sem nível mínimo → 2FA
  // ========================================================
  if (
    typeof usuario?.nivel_seguranca === 'number' &&
    usuario.nivel_seguranca < nivelMinimoSeguranca
  ) {
    if (typeof window !== 'undefined') {
      window.location.replace('/validacao-2fa');
    }
    return null;
  }

  // ========================================================
  // 4. Tudo OK → renderiza rota protegida
  // ========================================================
  return children;
}